import styled from 'styled-components/macro';

export const RedAccentLine = styled.div(p => ({
  height: 6,
  width: 54,
  borderRadius: '10px',
  backgroundColor: p.theme.red,
  marginTop: '0.75rem'
}));
